import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { EmployeeBadge, employeesQueryOptions } from '@/entities/employee'
import { fromISODate, toISODate } from '@/shared/lib'
import { CalendarBoard, useDefaultCalendarView } from '@/widgets/calendar-board'

const searchSchema = z.object({
  view: z.enum(['day', 'week', 'month']).optional().catch(undefined),
  date: z.string().optional().catch(undefined),
})

export const Route = createFileRoute('/_app/employees/$employeeId')({
  validateSearch: (search: Record<string, unknown>) => searchSchema.parse(search),
  component: EmployeeCalendarPage,
})

function EmployeeCalendarPage() {
  const { employeeId } = Route.useParams()
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  const defaultView = useDefaultCalendarView()
  const view = search.view ?? defaultView
  const anchor = (search.date ? fromISODate(search.date) : null) ?? new Date()
  const { data: employees = [] } = useQuery(employeesQueryOptions)
  const employee = employees.find((e) => e.id === employeeId)

  return (
    <div className="flex h-full min-h-0 flex-col">
      {employee && (
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1 border-b px-gutter py-2">
          <span className="label">Линза · сотрудник</span>
          <EmployeeBadge employee={employee} size="sm" />
        </div>
      )}
      <CalendarBoard
        lens={{ kind: 'employee', id: employeeId }}
        view={view}
        anchor={anchor}
        onViewChange={(v) => void navigate({ search: (s) => ({ ...s, view: v }) })}
        onAnchorChange={(d) => void navigate({ search: (s) => ({ ...s, date: toISODate(d) }) })}
        createDefaults={{ participantId: employeeId }}
      />
    </div>
  )
}
